<ng-content select="[description]"></ng-content>
<div class="input-wrapper">
  <ng-content select="input, textarea, select, app-icon, app-autocomplete, app-autocomplete-extended, app-picker"></ng-content>
  @if (type !== 'password' && hasError) {
    <app-input-error [controlName]="controlName()" [customErrors]="customErrors()" [group]="group()"></app-input-error>
  }
</div>
